import { makeContextModule } from '@cian/react-utils';

import { TActionPlacement } from '../../types/analytics';

export interface IAnalyticsContext {
  placement: TActionPlacement;
}

export const { Context: AnalyticsContext, useContext: useAnalyticsContext } = makeContextModule<IAnalyticsContext>({
  contextName: 'AnalyticsContext',
  // Без провайдера считаем, что элемент отрисован в таблице сравнения.
  defaultValue: { placement: 'table' },
});
